import * as yup from "yup";

import * as RHFUserValidationRules from "@/utils/validation/schemas/user.RHF";

export const LoginFormValidationSchema = yup.object({
    email: RHFUserValidationRules.email,
    password: RHFUserValidationRules.password
});

export type LoginFormValues = yup.InferType<typeof LoginFormValidationSchema>;
